import Grid from '@material-ui/core/Grid';
import { Header, InfoCard, /*Content*/ } from '@backstage/core-components';
import { EntityRefLink } from '@backstage/plugin-catalog-react';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { HeaderWorldClock, ClockConfig, HomePageToolkit, /*HomePageStarredEntities, HomePageRecentlyVisited*/ } from '@backstage/plugin-home';

const clockConfigs: ClockConfig[] = [{
      label: 'Boston',
      timeZone: 'America/New_York'
    }, {
      label: 'Limerick',
      timeZone: 'UTC'
    }, {
      label: 'Brno',
      timeZone: 'Europe/Prague'
    }, {
      label: 'Hyderabad',
      timeZone: 'Asia/Kolkata'
    }, {
        label: 'Singapore',
        timeZone: 'Asia/Singapore'
      },{
        label: 'Melbourne',
        timeZone: 'Australia/Sydney'
    }
];

const timeFormat: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};

import DocsIcon from '@mui/icons-material/Description';
import GitHubIcon from '@mui/icons-material/GitHub';
import SecurityIcon from '@mui/icons-material/Security';
import StorybookIcon from '@mui/icons-material/MenuBook';

const toolConfigs = [
    {
        url: 'https://design.infra360.org/',
        label: 'Design System',
        icon: <DocsIcon />
    },
    {
        url: 'https://storybook.infra360.org/',
        label: 'Design System',
        icon: <StorybookIcon />
    },
    {
        url: 'https://launcher.myapps.microsoft.com/api/signin/46355531-573a-42fd-9acd-a40e36889188?tenantId=db266a67-cbe0-4d26-ae1a-d0581fe03535',
        label: 'Veracode',
        icon: <SecurityIcon />
    },
    {
        url: 'https://launcher.myapps.microsoft.com/api/signin/722a3611-80a7-45b0-991e-402ae45a82e2?tenantId=db266a67-cbe0-4d26-ae1a-d0581fe03535',
        label: 'SonarQube',
        icon: <SecurityIcon />
    },
    {
        url: 'https://sonar.progress.com/dashboard',
        label: 'sonar.progress.com',
        icon: <SecurityIcon />
    },    
];  

const github360Orgs = [
    {
        url: 'https://github.com/orgs/Progress-I360/dashboard',
        label: 'Infra 360 TG',
        icon: <GitHubIcon />
    },  
    {
        url: 'https://github.com/orgs/progress-platform-services/dashboard',
        label: 'Chef 360',
        icon: <GitHubIcon />
    },  
]

const githubOrgs = [
    {
        url: 'https://github.com/orgs/chef/dashboard',
        label: 'Chef Infra & Automate',
        icon: <GitHubIcon />
    },  
    {
        url: 'https://github.com/orgs/inspec/dashboard',
        label: 'Chef InSpec',
        icon: <GitHubIcon />
    },  
]





export const HomePage = () => (
    <Grid container>
        <Grid item xs={12}>
            <Header title="Infra 360 - Developer Portal" pageTitleOverride="Home">
                <HeaderWorldClock  clockConfigs={clockConfigs} customTimeFormat={timeFormat} />
            </Header>
            <Grid container xs={12} justifyContent="center">
                <Grid item xs={10}><HomePageSearchBar /></Grid>                
            </Grid>            
        </Grid>            

        <Grid item xs={6}>
            <div style={{paddingLeft: "20px"}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <InfoCard title="Welcome">
                            <p>                                
                                Welcome to the experimental Infra 360 Developer Portal. 
                                This goal of the protal is to be a single place where you can find all the information 
                                you need to get started developming with or integrating to the Infra 360 family of products 
                                (e.g. Chef 360, Load Master 360, WhatsUp Gold 360, flowmon, etc).
                            </p>
                            <p>
                                On the right side of the page you will find a list of common tools or sites related to Infra 360 development.
                            </p>
                            <p>
                                For more information about the portal please review the backstage component (linked below), 
                                then select docs from the navigation menu, or explore the links found on the page.
                            </p>
                            <div style={{textAlign:"right"}}>
                                <EntityRefLink entityRef={{ kind: 'Component', namespace: 'default', name: 'backstage' }}>more</EntityRefLink>
                            </div>
                        </InfoCard>
                    </Grid>
                    <Grid item xs={12}>
                        <HomePageToolkit title="Github 360 Orgs" tools={github360Orgs}/>
                    </Grid>
                </Grid>
            </div>            
        </Grid>
        <Grid item xs={6}>
            <div style={{paddingRight: "20px"}}>
                <Grid container spacing={3}>
                <Grid item xs={12}>
                        <HomePageToolkit tools={toolConfigs}/>
                    </Grid>
                    <Grid item xs={12}>
                        <HomePageToolkit title="Github Product Orgs" tools={githubOrgs}/>
                    </Grid>
                </Grid>
            </div>
        </Grid>

    </Grid>
);
